export default __webpack_public_path__ + "static/media/17-thumbs-down_1f44e.c4356d92.png";